export const loadScript = async (src: string) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = src;
  return new Promise((resolve, reject) => {
    document.body.appendChild(script);
    script.onload = () => resolve(script);
    script.onerror = e => reject(e);
  });
};

const processJSXStyle = (key: string) => {
  if (!key) return '';
  return key
    .split('_')
    .map((w, i) => (i ? w[0].toUpperCase() + w.slice(1) : w))
    .join('');
};
export const toJSXStyle = (style: object) => {
  const newStyle: any = { ...style };
  const keys = Object.keys(newStyle);
  for (const key of keys) {
    const newKey = processJSXStyle(key);
    newStyle[newKey] = newStyle[key];
    delete newStyle[key];
  }
  return newStyle;
};
